/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY Backend
 * PEXIFY operating system backend — privately governed commerce ecosystem. M3 başlangıcı: FastAPI shell. Faz 1-6 schema RATIFIED; per-component CRUD + RBAC + audit emit + engines (M-AUDIT / M-WALLET / M-POLICY / M-NOTIF) coming.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAdminProblemReportNotificationTarget401,
  GetAdminProblemReportNotificationTarget403,
  GetAdminProblemReportNotificationTarget404,
  GetAdminProblemReportNotificationTarget405,
  GetAdminProblemReportNotificationTarget409,
  GetAdminProblemReportNotificationTarget413,
  GetAdminProblemReportNotificationTarget422,
  GetAdminProblemReportNotificationTarget429,
  GetAdminProblemReportNotificationTarget500,
  GetAdminProblemReportNotificationTarget503,
  ProblemReportNotificationTarget
} from '../model';

import { orvalClient } from '../../orval-client';




export type getAdminProblemReportNotificationTargetResponse200 = {
  data: ProblemReportNotificationTarget
  status: 200
}

export type getAdminProblemReportNotificationTargetResponse401 = {
  data: GetAdminProblemReportNotificationTarget401
  status: 401
}

export type getAdminProblemReportNotificationTargetResponse403 = {
  data: GetAdminProblemReportNotificationTarget403
  status: 403
}

export type getAdminProblemReportNotificationTargetResponse404 = {
  data: GetAdminProblemReportNotificationTarget404
  status: 404
}

export type getAdminProblemReportNotificationTargetResponse405 = {
  data: GetAdminProblemReportNotificationTarget405
  status: 405
}

export type getAdminProblemReportNotificationTargetResponse409 = {
  data: GetAdminProblemReportNotificationTarget409
  status: 409
}

export type getAdminProblemReportNotificationTargetResponse413 = {
  data: GetAdminProblemReportNotificationTarget413
  status: 413
}

export type getAdminProblemReportNotificationTargetResponse422 = {
  data: GetAdminProblemReportNotificationTarget422
  status: 422
}

export type getAdminProblemReportNotificationTargetResponse429 = {
  data: GetAdminProblemReportNotificationTarget429
  status: 429
}

export type getAdminProblemReportNotificationTargetResponse500 = {
  data: GetAdminProblemReportNotificationTarget500
  status: 500
}

export type getAdminProblemReportNotificationTargetResponse503 = {
  data: GetAdminProblemReportNotificationTarget503
  status: 503
}

export type getAdminProblemReportNotificationTargetResponseSuccess = (getAdminProblemReportNotificationTargetResponse200) & {
  headers: Headers;
};
export type getAdminProblemReportNotificationTargetResponseError = (getAdminProblemReportNotificationTargetResponse401 | getAdminProblemReportNotificationTargetResponse403 | getAdminProblemReportNotificationTargetResponse404 | getAdminProblemReportNotificationTargetResponse405 | getAdminProblemReportNotificationTargetResponse409 | getAdminProblemReportNotificationTargetResponse413 | getAdminProblemReportNotificationTargetResponse422 | getAdminProblemReportNotificationTargetResponse429 | getAdminProblemReportNotificationTargetResponse500 | getAdminProblemReportNotificationTargetResponse503) & {
  headers: Headers;
};

export type getAdminProblemReportNotificationTargetResponse = (getAdminProblemReportNotificationTargetResponseSuccess | getAdminProblemReportNotificationTargetResponseError)

export const getGetAdminProblemReportNotificationTargetUrl = (notificationId: string,) => {




  return `/api/v1/admin/problem-reports/notifications/${notificationId}/target`
}

/**
 * @summary Notification Target
 */
export const getAdminProblemReportNotificationTarget = async (notificationId: string, options?: RequestInit): Promise<getAdminProblemReportNotificationTargetResponse> => {

  return orvalClient<getAdminProblemReportNotificationTargetResponse>(getGetAdminProblemReportNotificationTargetUrl(notificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminProblemReportNotificationTargetQueryKey = (notificationId: string,) => {
    return [
    `/api/v1/admin/problem-reports/notifications/${notificationId}/target`
    ] as const;
    }


export const getGetAdminProblemReportNotificationTargetQueryOptions = <TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = GetAdminProblemReportNotificationTarget401 | GetAdminProblemReportNotificationTarget403 | GetAdminProblemReportNotificationTarget404 | GetAdminProblemReportNotificationTarget405 | GetAdminProblemReportNotificationTarget409 | GetAdminProblemReportNotificationTarget413 | GetAdminProblemReportNotificationTarget422 | GetAdminProblemReportNotificationTarget429 | GetAdminProblemReportNotificationTarget500 | GetAdminProblemReportNotificationTarget503>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminProblemReportNotificationTargetQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>> = ({ signal }) => getAdminProblemReportNotificationTarget(notificationId, { signal });





   return  { queryKey, queryFn, enabled: notificationId !== null && notificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminProblemReportNotificationTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>>
export type GetAdminProblemReportNotificationTargetQueryError = GetAdminProblemReportNotificationTarget401 | GetAdminProblemReportNotificationTarget403 | GetAdminProblemReportNotificationTarget404 | GetAdminProblemReportNotificationTarget405 | GetAdminProblemReportNotificationTarget409 | GetAdminProblemReportNotificationTarget413 | GetAdminProblemReportNotificationTarget422 | GetAdminProblemReportNotificationTarget429 | GetAdminProblemReportNotificationTarget500 | GetAdminProblemReportNotificationTarget503


export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = GetAdminProblemReportNotificationTarget401 | GetAdminProblemReportNotificationTarget403 | GetAdminProblemReportNotificationTarget404 | GetAdminProblemReportNotificationTarget405 | GetAdminProblemReportNotificationTarget409 | GetAdminProblemReportNotificationTarget413 | GetAdminProblemReportNotificationTarget422 | GetAdminProblemReportNotificationTarget429 | GetAdminProblemReportNotificationTarget500 | GetAdminProblemReportNotificationTarget503>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = GetAdminProblemReportNotificationTarget401 | GetAdminProblemReportNotificationTarget403 | GetAdminProblemReportNotificationTarget404 | GetAdminProblemReportNotificationTarget405 | GetAdminProblemReportNotificationTarget409 | GetAdminProblemReportNotificationTarget413 | GetAdminProblemReportNotificationTarget422 | GetAdminProblemReportNotificationTarget429 | GetAdminProblemReportNotificationTarget500 | GetAdminProblemReportNotificationTarget503>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = GetAdminProblemReportNotificationTarget401 | GetAdminProblemReportNotificationTarget403 | GetAdminProblemReportNotificationTarget404 | GetAdminProblemReportNotificationTarget405 | GetAdminProblemReportNotificationTarget409 | GetAdminProblemReportNotificationTarget413 | GetAdminProblemReportNotificationTarget422 | GetAdminProblemReportNotificationTarget429 | GetAdminProblemReportNotificationTarget500 | GetAdminProblemReportNotificationTarget503>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Notification Target
 */

export function useGetAdminProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError = GetAdminProblemReportNotificationTarget401 | GetAdminProblemReportNotificationTarget403 | GetAdminProblemReportNotificationTarget404 | GetAdminProblemReportNotificationTarget405 | GetAdminProblemReportNotificationTarget409 | GetAdminProblemReportNotificationTarget413 | GetAdminProblemReportNotificationTarget422 | GetAdminProblemReportNotificationTarget429 | GetAdminProblemReportNotificationTarget500 | GetAdminProblemReportNotificationTarget503>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminProblemReportNotificationTargetQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






